// Pure adherence-streak math. Given a scheduled item and a window of
// intake_log rows, walks back day-by-day from `todayIso` and counts
// consecutive days on which every scheduled dose has a matching
// intake_log row.
//
// Strict rule per the Phase 4 spec: the walk starts at today. If today
// isn't fully covered, the streak is 0 — no grace through unfinished
// days. If we want lenient behaviour later, the one-line change is to
// skip today when `taken` is empty for it and start the walk at
// yesterday.

export function addDaysIso(iso, delta) {
  // Anchored in UTC so DST transitions in the browser's local zone
  // don't shift the date — streak boundaries are always 24h apart in
  // wall-clock terms.
  const d = new Date(`${iso}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + delta)
  return d.toISOString().slice(0, 10)
}

export function computeAdherenceStreak({ item, itemKind, intakeRows, todayIso }) {
  if (!item || !Array.isArray(item.schedule_times) || item.schedule_times.length === 0) return 0
  if (item.stopped_at) return 0

  const taken = new Set()
  for (const r of intakeRows) {
    if (r.item_kind !== itemKind) continue
    if (r.item_id !== item.id) continue
    if (!r.scheduled_time) continue
    taken.add(`${r.date}#${r.scheduled_time}`)
  }

  let streak = 0
  let day = todayIso
  for (let i = 0; i < 365; i++) {
    const allCovered = item.schedule_times.every((time) => taken.has(`${day}#${time}`))
    if (!allCovered) break
    streak += 1
    day = addDaysIso(day, -1)
  }
  return streak
}
